import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconArrowNext({
    color = '#fff',
    className,
    ariaHidden = false,
    size = 20,
}: IconProps): ReactElement {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            viewBox='0 0 14 16'
            fill='none'
            className={className}
            aria-hidden={ariaHidden}
        >
            <path
                d='M1 8h12M13 8 6.953 1.953M13 8l-6.047 6.047'
                stroke={color}
                strokeWidth={2}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
